<template>
  <div class="atualizaco-funcionario">
    <div>
      <PageTitle
        isBack="true"
        link="rh"
        fontSize="25"
        icon="fa fa-microchip"
        title="Recursos Humanos // Atualização de Funcionário"
      />
    </div>
    <!-- filtros da lista -->
    <div class="container-funcionario">
      <header>
        <div class="box-item">
          <span style="margin-bottom: 5px;">Pesquisa</span>
          <b-form-select
            style="width: 180px;height: 35px;"
            icon="arrow_downward"
            :options="dataPesquisa"
            v-model="pesquisa"
            @input="eventSelectedPesquisa"
          ></b-form-select>
        </div>
        <div class="search-box">
          <span style="margin-bottom: 5px;">Valor Pesquisado</span>
          <vs-input icon="search" style="width: 100%" v-model="searchBox" v-on:keyup.enter="clickSearch" />
        </div>
        <button class="btn-serach-funcionario" @click="clickSearch">Pesquisar</button>
      </header>
      <!-- fim -->
      <!-- lista de colaboradores -->
      <div class="table-collaborator-funcionario" v-if="pessoaData.length > 0 " >
        <table>
          <tr>
            <th><b>Matrícula</b></th>
            <th><b>Nome</b></th>
            <th><b>E-mail</b></th>
            <th><b>Documento</b></th>
            <th><b>Ação</b></th>
          </tr>
          <tr v-for="(pessoa, index) in pessoaData" :key="index">
            <td>{{ pessoa.matricula }}</td>
            <td>{{ pessoa.nome }}</td>
            <td>{{ pessoa.email }}</td>
            <td>{{ pessoa.documento }}</td>
            <td>
              <button class="btn-reject-funcionario" @click="abrePopup(pessoa)">Atualizar</button>
            </td>
          </tr>
        </table>
      </div>
      <!-- fim -->
    </div>
    <!-- poupap para atualizar -->
    <vs-popup title="Deseja realmente atualizar os dados desse usuário?" :active.sync="popupActivo">
        <div>
            <vs-button color="success" @click="clickYesPopup" type="filled">Sim</vs-button>
            <vs-button color="danger" @click="clickNoPopup" type="filled">Não</vs-button>
          </div>
      </vs-popup>
      <div>
        <p style="margin: 20px 0px 0px 45px; font-style: italic; color: #555;">
          Atualização dos dados do funcionário na Clicksign com base nas informações cadastradas na Novo Tempo.
        </p>
      </div>
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrlRH } from "@/global";
import { EventBusExpenses } from "@/eventBus/eventBusExpenses";

import PageTitle from "@/components/template/PageTitle";

const configMessage = {
  iconPack: "fontawesome",
  position: "top-center",
  className: ["toast-global"],
  type: "error",
  duration: 5000
};

const configMessageYes = {
  iconPack: "fontawesome",
  position: "top-center",
  className: ["toast-global"],
  type: "success",
  duration: 3000
};

export default {
  name: "AtualizacaoFuncionario",
  components: { PageTitle },
  data() {
    return {
      searchBox: "",
      pessoaData: [],
      popupActivo: false,
      dataPesquisa: [
        { text: "Matrícula", value: "1" },
        { text: "Nome", value: "2" }
      ],
      pesquisa:"2",
      selectedPerson: null
    };
  },

  methods: {
    eventSelectedPesquisa() {
      this.pessoaData= [];
      this.searchBox = "";
    },
    async clickSearch() {
      try {
        this.pessoaData= [];
        this.pesquisa;
        if(this.searchBox == ""){
          this.$toasted.show("Valor Pesquisado não pode estar em branco!", configMessage);
          return;
        }

        const response = await axios.post(
          `${baseApiUrlRH}/pessoa/busca-pessoa/${this.pesquisa}`,
          this.searchBox,
          {headers: {'Content-Type': 'text/plain', },
          }
        );
        this.popupActivo = false;
        this.pessoaData = response.data;
        if(this.pessoaData.length == 0){
          this.$toasted.show("Funcionário não encontrado!", configMessage);
        }
      } catch (error) {
        console.error(error);
      }
    },

    abrePopup(requestVacation) {
      this.selectedPerson = requestVacation;
      this.popupActivo = true;
    },

    clickNoPopup() {
      this.popupActivo = false;
    },

    async clickYesPopup() {
      this.$vs.loading({ text: "Atualizando cadastro funcionário..." });
      console.log(this.selectedPerson.personId)
      try {
        const resp = await axios.post(`${baseApiUrlRH}/pessoa/atualiza-pessoa/${this.selectedPerson.personId}`);        
        this.popupActivo = false;
        this.$toasted.show("Atualização realizada!", configMessageYes);
      } catch (error) {
        this.$toasted.show("Atualização não realizada!", configMessage);
      } finally {
        this.pessoaData= [];
        this.searchBox="";
        this.$vs.loading.close();
      }
    },
  },

};
</script>

<style scoped src="./style.css"></style>
